export default __webpack_public_path__ + "images/38da242e026ba2d7fee3a7043985241f.png";